import React from 'react';
import { Check } from 'lucide-react';
import { Card } from 'components/ui/card';
import { categoriesDetails } from 'data/Pilgrims';
import { formatNumber } from '../data';

const Pricing = ({ data, status }) => (
  <section
    id="tarification"
    className="bg-[#f3f2e8] py-11 min-[681px]:py-16 [&_h2]:text-center"
    aria-labelledby="tariff-title"
  >
    <div className="mx-auto w-[calc(100%-40px)] max-w-[470px] min-[681px]:w-[calc(100%-80px)] min-[681px]:max-w-[950px] xl:max-w-[1320px]">
      <h2 id="tariff-title" className="font-semibold leading-[1.3] text-inherit text-[25px] min-[681px]:text-[30px]">
        Tarification Hajj{data ? ` ${data.quota.campaign_year}` : ''}
      </h2>
      {data?.preferences.hajj_pricing_information && (
        <p className="mx-auto mt-4 max-w-[820px] whitespace-pre-line text-center text-[#586357]">
          {data.preferences.hajj_pricing_information}
        </p>
      )}
      {!data ? (
        status
      ) : (
        <div className="mt-[34px] grid grid-cols-1 gap-[18px] min-[681px]:grid-cols-2 xl:grid-cols-4">
          {data.publicCategories.map((category) => {
            const details = categoriesDetails[category.name];
            const [service, ...extras] = details.service.split('\n').map((line) => line.trim());
            const features = [
              details.transport,
              `Mecque : ${details.mecca}`,
              `Médine : ${details.medina}`,
              `Service Mina & Arafat : ${service}`,
              ...extras,
            ];
            return (
              <article key={category.id} className="min-w-0" aria-label={category.label}>
                <Card className="h-full overflow-hidden rounded-[13px] border-[#dce3db] bg-white text-[#30372d] shadow-none">
                  <div className="px-[19px] pt-6 [&>p:first-child]:text-[13px] [&>p:first-child]:text-[#586357] [&_h3]:mt-[3px] [&_h3]:text-[22px] [&_h3]:text-[#00472f]">
                    <p className="text-base leading-[inherit] text-inherit">{category.audience}</p>
                    <h3 className="font-semibold leading-[1.3] text-inherit text-[21px]">{category.tier}</h3>
                    <p className="mt-4 text-[30px] font-semibold leading-[1.2] text-[#00472f] [&>span]:mt-[5px] [&>span]:block [&>span]:text-xs [&>span]:font-medium">
                      {formatNumber(category.price.public)} <span>FCFA</span>
                    </p>
                    <div className="mb-[18px] mt-4 rounded-lg border border-[#a0b89d] bg-[#f3f7e9] px-[13px] py-2.5 min-[681px]:min-h-[110px] [&>span]:block [&>span]:text-xs [&>span]:text-[#47643c] [&_strong]:block [&_strong]:text-[26px] [&_strong]:leading-[1.5] [&_strong]:text-[#31502e]">
                      <span>Places disponibles</span>
                      <strong>{formatNumber(category.quota.available)}</strong>
                      <span>
                        {category.quota.shared
                          ? `${formatNumber(category.quota.total)} places partagées entre Standard et Premium`
                          : `sur ${formatNumber(category.quota.total)} places allouées`}
                      </span>
                    </div>
                  </div>
                  <ul className="flex flex-col gap-3.5 border-t border-[#e8ebe4] px-[19px] pb-6 pt-[21px] text-sm leading-[1.65] [&_li]:flex [&_li]:items-start [&_li]:gap-[9px] [&_svg]:mt-1 [&_svg]:flex-[0_0_15px] [&_svg]:rounded-full [&_svg]:bg-[#eef3e7] [&_svg]:text-[#557543]">
                    {features.map((feature) => (
                      <li key={feature}>
                        <Check size={15} aria-hidden="true" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </Card>
              </article>
            );
          })}
        </div>
      )}
    </div>
  </section>
);
export default Pricing;
